<ng-container *ngIf="screenWidth > 991; else mobileView">
    <main>

        <div class="row mt-4">
            <ng-container *ngIf="hero">
                <div class="bg-image rounded-end" style="
            background-image: url({{hero.heroImage.fields.file.url}});
            height: 300px;
            ">
                    <div class="col-sm-6 p-0 ">
                        <div class="p-5 catalog-hero d-flex align-items-center rounded-start"
                            style="background: transparent">
                            <div class="vw-50">
                                <h1 class="mb-3 fs-3 fw-bolder base-font"><b>{{hero.heroText ? hero.heroText : ''}}</b>
                                </h1>
                                <p class="mb-3 base-font">{{hero.heroSubText ? hero.heroSubText : ''}}</p>
                                <ng-container *ngIf="hero.heroBtnText">
                                    <a class="btn catalog-hero-button base-font" href="{{hero.heroBtnUrl}}"
                                        role="button">{{hero.heroBtnText}}</a>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            <!-- <ng-container *ngIf="subcategory">
                <div class="row mt-4">
                    <div class="col-sm-12">
                        <h3 class="base-font fs-4">{{subcategory.sectionName}}</h3>
                        <div class="d-flex justify-content-between">
                            <div class="clearfix d-flex align-items-center pe-2">
                                <i class="fas fa-chevron-left float-start" (click)="scrollLeft(overflowSubCategories)"
                                    *ngIf="subcategory.subcategories.length > 6"></i>
                            </div>
                            <div class="custom-scroll-main" #overflowSubCategories>
                                <div class="col-sm-2 text-center bg-image hover-overlay ripple rounded px-1"
                                    data-mdb-ripple-color="light" *ngFor="let garment of subcategory.subcategories">
                                    <a (click)="browseSubcategory(garment.fields.description)">
                                        <img src="{{garment.fields.file.url}}" class="img-fluid rounded-circle"
                                        [alt]="'Subcategory Image of ' + garment.fields.title"  loading="lazy" />
                                        <div class="mask" style="background-color: rgba(251, 251, 251, 0.2);"></div>
                                    </a>

                                    <p class="text-center base-font">
                                        {{ garment.fields.title }}
                                    </p>
                                </div>
                            </div>
                            <div class="d-flex align-items-center pe-2" *ngIf="subcategory.subcategories.length > 6">
                                <i class="fas fa-chevron-right float-end"
                                    (click)="scrollRight(overflowSubCategories)"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container> -->
        </div>

        <div class="row g-3 mt-2 p-4">

            <div id="sticky-list" class="clearfix sticky">
                <div class="row">
                    <div class="col-12">
                        <ng-container *ngIf="products">
                            <div class="float-start">
                                {{ currentPageRange }}
                            </div>
                        </ng-container>
                    </div>
                    <div class="col-12 mt-1">
                        <div class="chips d-flex align-items-center overflow-scroll">
                            <div class="flex-shrink-0 filter-button" (click)="hideFilterList()">
                                <i
                                    [ngClass]="isFilterListVisible ? 'fas fa-times-circle mx-1 fa-xs' : ' fas fa-filter mx-1 fa-xs'"></i>
                                <span>Filters</span>
                            </div>
                            <div class="flex-shrink-0 sort-button" mdbDropdown>
                                <button type="button" id="dropdownMenuButton" aria-expanded="false" mdbDropdownToggle
                                    data-mdb-display="static">
                                    <i class="fas fa-sort mx-2 fa-xs"></i>
                                    <span>{{selectedSortOption ? selectedSortOption : 'Sort By'}}</span>
                                </button>
                                <ul mdbDropdownMenu class="dropdown-menu navbar-user-dropdown dropdown-menu-end"
                                    aria-labelledby="dropdownMenuLink">
                                    <li [ngClass]="{ 'selected': selectedSortOption === 'A-Z' }">
                                        <a class="dropdown-item" (click)="sortProducts('A-Z')">
                                            <i class="fas fa-sort-alpha-down pe-1"></i>
                                            A-Z by Brand
                                        </a>
                                    </li>
                                    <li [ngClass]="{ 'selected': selectedSortOption === 'Z-A' }">
                                        <a class="dropdown-item" (click)="sortProducts('Z-A')">
                                            <i class="fas fa-sort-alpha-down-alt pe-1"></i>
                                            Z-A by Brand
                                        </a>
                                    </li>
                                    <!-- <li [ngClass]="{ 'selected': selectedSortOption === 'High Inventory' }">
                                    <a class="dropdown-item" (click)="sortProducts('High Inventory')">
                                        <i class="fas fa-boxes pe-1"></i>
                                        High Inventory
                                    </a>
                                </li> -->
                                </ul>
                            </div>
                            <div class="tag-container">
                                <ng-container *ngIf="mongoParam">
                                    <ng-container *ngFor="let tag of mongoParam">
                                        <button type="button" class="btn-rounded btn-sm filter-pills" mdbRipple
                                            rippleColor="dark" (click)="removeTag(tag)">
                                            {{ getValueFromObject(tag) | titlecase }}
                                            <i class="close fas fa-times"></i>
                                        </button>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </div>
                    </div>


                </div>
            </div>

            <hr class="hr" />

            <ng-container>
                <div class="col-3 sticky-wrapper">
                    <mdb-accordion mdbScrollbar style=" height: 80%" class="borderless-accordion" id="sticky-filter">

                        <mdb-accordion-item style="background-color: #FFF;">
                            <ng-template mdbAccordionItemHeader>
                                <strong>Brands</strong>
                            </ng-template>
                            <ng-template mdbAccordionItemBody>
                                <ul class="list-group list-group-flush overflow-scroll" style="height: 300px;">
                                    <ng-container *ngIf="brandsFilter && brandsFilter.Brands">
                                        <li class="list-group-item border-0" *ngFor="let option of brandsFilter.Brands | filterNull; let i = index">
                                            <input mdbCheckbox class="form-check-input me-1" type="checkbox"
                                                aria-label="Filter Label" (click)="applyFilter('brands', option)" [id]="'brands_' + i"/>
                                            <label [for]="'brand_' + i" style="font-size: 12px;">{{ option }}</label>
                                        </li>
                                    </ng-container>
                                </ul>
                            </ng-template>
                        </mdb-accordion-item>

                        <mdb-accordion-item>
                            <ng-template mdbAccordionItemHeader>
                                <strong>Categories</strong>
                            </ng-template>
                            <ng-template mdbAccordionItemBody>
                                <ul class="list-group list-group-flush overflow-scroll" style="height: 300px;">
                                    <ng-container *ngIf="categoriesFilter && categoriesFilter.Categories">
                                        <li class="list-group-item border-0" *ngFor="let option of categoriesFilter.Categories | filterNull; let i = index">
                                            <input mdbCheckbox class="form-check-input me-1" type="checkbox"
                                                aria-label="Filter Label" [id]="'categories_' + i" (click)="applyFilter('categories', option)" />
                                            <label [for]="'categories_' + i" style="font-size: 12px;">{{ option | titlecase}}</label>
                                        </li>
                                    </ng-container>
                                </ul>
                            </ng-template>
                        </mdb-accordion-item>

                        <mdb-accordion-item>
                            <ng-template mdbAccordionItemHeader>
                                <strong>Color</strong>
                            </ng-template>
                            <ng-template mdbAccordionItemBody>
                                <ul class="list-group list-group-flush">
                                    <li class="list-group-item border-0" *ngFor="let option of colors | filterNull; let i = index">
                                        <input mdbCheckbox class="form-check-input me-1" type="checkbox" [id]="'color_' + i"
                                            aria-label="Filter Label" (click)="applyFilter('colors', option)" />
                                        <label [for]="'color_' + i" style="font-size: 12px;">{{ option }}</label>
                                    </li>
                                </ul>
                            </ng-template>
                        </mdb-accordion-item>

                        <mdb-accordion-item>
                            <ng-template mdbAccordionItemHeader>
                                <strong>Thickness</strong>
                            </ng-template>
                            <ng-template mdbAccordionItemBody>
                                <ul class="list-group list-group-flush">
                                    <li class="list-group-item border-0" *ngFor="let option of thickness | filterNull; let i = index">
                                        <input mdbCheckbox class="form-check-input me-1" type="checkbox"
                                            aria-label="Filter Label" [id]="'thickness_' + i" (click)="applyFilter('unitWeightRange', option.value)" />
                                        <label [for]="'thickness_' + i" style="font-size: 12px;">{{ option.label }}</label>
                                    </li>
                                </ul>
                            </ng-template>
                        </mdb-accordion-item>
                        <mdb-accordion-item>
                            <ng-template mdbAccordionItemHeader>
                                <strong>Price</strong>
                            </ng-template>
                            <ng-template mdbAccordionItemBody>
                                <ul class="list-group list-group-flush">
                                    <li class="list-group-item border-0" *ngFor="let option of price | filterNull; let i = index">
                                        <ng-container *ngIf="option">
                                            <input mdbCheckbox class="form-check-input me-1" type="checkbox" [id]="'price_' + i"
                                                aria-label="Filter Label" (click)="applyFilter('priceRange', option)" />
                                            <label [for]="'price_' + i" style="font-size: 12px;">${{ option }}</label>
                                        </ng-container>
                                    </li>
                                </ul>
                            </ng-template>
                        </mdb-accordion-item>
                    </mdb-accordion>
                    <ng-container *ngIf="isFilterListVisible">
                        <div class="d-flex justify-content-center w-100 filter-button-container mt-4">
                            <button type="button" class="btn btn-outline-primary me-1 w-50 filter-reset" mdbRipple
                                (click)="clearFilters()">Reset</button>
                            <button type="button" class="btn btn-primary w-50 filter-apply" mdbRipple
                                (click)="submitFilters()">Apply</button>
                        </div>
                    </ng-container>
                </div>
                <!-- table start -->
                <div
                    [ngClass]="isFilterListVisible ? 'col-9 slide-transition slide-in' : 'col-12 slide-transition slide-out'">
                    <div class="row">
                        <ng-container *ngIf="products && products.length > 0; else noResults">
                            <ng-container *ngFor="let item of products ">
                                <ng-container *ngIf="item.images">
                                    <ng-container *ngIf="item.images.front || item.images[0]">
                                        <div
                                            [ngClass]="isFilterListVisible ? 'col-6 col-md-4 col-lg-3 col-xxl-3' : 'col-6 col-md-4 col-lg-3 col-xxl-2'">
                                            <app-product-card [product]="item" [viewport]="viewport"></app-product-card>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </div>

                    <nav aria-label="Page navigation example" class="d-flex justify-content-center">
                        <ng-container *ngIf="products">
                            <ng-container *ngIf="countProductsResult > products.length">
                                <button class="btn btn-primary w-25 filter-apply mt-2" type="button"
                                    (click)="getMoreProducts(currentPage + 1, selectedSortOption)" mdbRipple>
                                    {{loading ? 'Loading' : 'Load More'}}
                                    <div *ngIf="loading" class="autocomplete-loader spinner-border me-3" role="status">
                                    </div>
                                </button>
                            </ng-container>
                        </ng-container>
                    </nav>
                </div>
                <!-- table end -->
            </ng-container>
        </div>

    </main>

</ng-container>

<ng-template #mobileView>
    <ng-container *ngIf="hero">
        <div class="p-0 ">
            <div class="p-5 catalog-hero d-flex align-items-center justify-content-center text-center" style="
            background-image: url({{hero.heroImage.fields.file.url}});
            background-size: cover; height: 60vh;
            height: 300px;
            ">
                <div class="vw-50">
                    <h1 class="mb-3 fs-3 fw-bolder base-font"><b>{{hero.heroText}}</b></h1>
                    <p class="mb-3 base-font">{{hero.heroSubText}}</p>
                    <ng-container *ngIf="hero.heroBtnText">
                        <a class="btn catalog-hero-button base-font" href="{{hero.heroBtnUrl}}"
                            role="button">{{hero.heroBtnText}}</a>
                    </ng-container>
                </div>
            </div>
        </div>
    </ng-container>

    <div id="sticky-list" class="clearfix sticky">
        <div class="row">
            <ng-container *ngIf="currentPage && itemsPerPage && countProductsResult && mongoParam">
                <div class="display-6 text-center my-0">{{queryHeader | titlecase}}</div>
                <div class="text-center">
                    {{ currentPageRange }}
                </div>
            </ng-container>
        </div>
        <div class="row">
            <div class="col-12 mt-1">
                <div class="d-flex justify-content-center w-100 mt-2 mb-2">
                    <button type="button" class="btn btn-outline-primary me-1 flex-grow-1  filter-mobile" mdbRipple
                        (click)="sidenav.toggle()">Filters
                        <i class="fas fa-angle-down mx-1"></i>
                    </button>



                    <div mdbDropdown class="flex-fill">
                        <button class="btn btn-outline-primary filter-mobile w-100" type="button"
                            id="dropdownMenuButton" aria-expanded="false" mdbDropdownToggle data-mdb-display="static">
                            <span>{{selectedSortOption ? selectedSortOption : 'Sort By'}}</span>
                            <i class="fas fa-sort mx-1 fa-xs"></i>
                        </button>
                        <ul mdbDropdownMenu class="dropdown-menu navbar-user-dropdown dropdown-menu-end"
                            aria-labelledby="dropdownMenuLink">
                            <li [ngClass]="{ 'selected': selectedSortOption === 'A-Z' }">
                                <a class="dropdown-item" (click)="sortProducts('A-Z')">
                                    <i class="fas fa-sort-alpha-down pe-1"></i>
                                    A-Z by Brand
                                </a>
                            </li>
                            <li [ngClass]="{ 'selected': selectedSortOption === 'Z-A' }">
                                <a class="dropdown-item" (click)="sortProducts('Z-A')">
                                    <i class="fas fa-sort-alpha-down-alt pe-1"></i>
                                    Z-A by Brand
                                </a>
                            </li>
                            <!-- <li [ngClass]="{ 'selected': selectedSortOption === 'High Inventory' }">
                                <a class="dropdown-item" (click)="sortProducts('High Inventory')">
                                    <i class="fas fa-boxes pe-1"></i>
                                    High Inventory
                                </a>
                            </li> -->
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <ng-container *ngIf="products && products.length > 0; else noResults">
            <ng-container *ngFor="let item of products ">
                <ng-container *ngIf="item && item.images">
                    <div
                        [ngClass]="isFilterListVisible ? 'col-6 col-md-4 col-lg-3 col-xxl-3' : 'col-6 col-md-4 col-lg-3 col-xxl-2'">
                        <app-product-card [product]="item" [viewport]="viewport"></app-product-card>
                    </div>
                </ng-container>
            </ng-container>
        </ng-container>
    </div>
    <div class="row pe-3 ps-3">
        <ng-container *ngIf="products">
            <ng-container *ngIf="countProductsResult > products.length">
                <button class="btn btn-primary w-100 filter-apply mt-2" type="button"
                    (click)="getMoreProducts(currentPage + 1)" mdbRipple>
                    <span>
                        Load More
                    </span>
                </button>
            </ng-container>
        </ng-container>

    </div>
    <mdb-sidenav-layout>
        <mdb-sidenav #sidenav="mdbSidenav">
            <ul class="sidenav-menu">
                <mdb-sidenav-item>
                    <a class="sidenav-link sidenav-link-mobile-name" tabindex="0">
                        <i class=""></i><span><strong>Brands</strong></span>
                    </a>
                    <ul class="sidenav-collapse" mdbCollapse>
                        <ng-container *ngIf="brandsFilter && brandsFilter.Brands">
                            <li class="list-group-item border-0" *ngFor="let option of brandsFilter.Brands | filterNull; let i = index">
                                <input mdbCheckbox class="form-check-input me-1" type="checkbox"
                                    aria-label="Filter Label" (click)="applyFilter('brands', option)" [id]="'brand_' + i"/>
                                <label [for]="'brand_' + i" style="font-size: 12px;">{{ option }}</label>
                            </li>
                        </ng-container>
                    </ul>
                </mdb-sidenav-item>

                <mdb-sidenav-item>
                    <a class="sidenav-link sidenav-link-mobile-name" tabindex="0">
                        <i class=""></i><span><strong>Categories</strong></span>
                    </a>
                    <ul class="sidenav-collapse" mdbCollapse>
                        <ng-container *ngIf="categoriesFilter && categoriesFilter.Categories">
                            <li class="list-group-item border-0" *ngFor="let option of categoriesFilter.Categories | filterNull; let i = index">
                                <input mdbCheckbox class="form-check-input me-1" type="checkbox" 
                                    aria-label="Filter Label" (click)="applyFilter('categories', option)" [id]="'category_' + i"/>
                                <label [for]="'category_' + i" style="font-size: 12px;">{{ option | titlecase}}</label>
                            </li>
                        </ng-container>
                    </ul>
                </mdb-sidenav-item>

                <mdb-sidenav-item>
                    <a class="sidenav-link sidenav-link-mobile-name" tabindex="0">
                        <i class=""></i><span><strong>Colors</strong></span>
                    </a>
                    <ul class="sidenav-collapse" mdbCollapse>
                        <li class="list-group-item border-0" *ngFor="let option of colors | filterNull; let i = index">
                            <input mdbCheckbox class="form-check-input me-1" type="checkbox"
                                aria-label="Filter Label" (click)="applyFilter('colors', option)" [id]="'color_' + i"/>
                            <label [for]="'color_' + i" style="font-size: 12px;">{{ option }}</label>
                        </li>
                    </ul>
                </mdb-sidenav-item>

                <mdb-sidenav-item>
                    <a class="sidenav-link sidenav-link-mobile-name" tabindex="0">
                        <i class=""></i><span><strong>Thickness</strong></span>
                    </a>
                    <ul class="sidenav-collapse" mdbCollapse>
                        <li class="list-group-item border-0" *ngFor="let option of thickness | filterNull; let i = index">
                            <input mdbCheckbox class="form-check-input me-1" type="checkbox"
                                aria-label="Filter Label" (click)="applyFilter('unitWeightRange', option.value)" [id]="'thickness_' + i"/>
                            <label [for]="'thickness_' + i" style="font-size: 12px;">{{ option.label }}</label>
                        </li>
                    </ul>
                </mdb-sidenav-item>

                <mdb-sidenav-item>
                    <a class="sidenav-link sidenav-link-mobile-name" tabindex="0">
                        <i class=""></i><span><strong>Price</strong></span>
                    </a>
                    <ul class="sidenav-collapse" mdbCollapse>
                        <li class="list-group-item border-0" *ngFor="let option of price | filterNull; let i = index">
                            <input mdbCheckbox class="form-check-input me-1" type="checkbox"
                                aria-label="Filter Label" (click)="applyFilter('priceRange', option)" [id]="'price_' + i"/>
                            <label [for]="'price_' + i" style="font-size: 12px;">${{ option }}</label>
                        </li>
                    </ul>
                </mdb-sidenav-item>
            </ul>

            <div class="d-flex justify-content-center w-100 filter-button-container-mobile mt-2 mb-2">
                <button type="button" class="btn btn-outline-primary me-1 w-50 filter-reset" mdbRipple
                    (click)="clearFilters()" (click)="sidenav.toggle()">Reset</button>
                <button type="button" class="btn btn-primary w-50 filter-apply" mdbRipple (click)="submitFilters()"
                    (click)="sidenav.toggle()">Apply</button>
            </div>
        </mdb-sidenav>
        <mdb-sidenav-content #sidenavContent></mdb-sidenav-content>
    </mdb-sidenav-layout>

</ng-template>

<ng-template #noResults>
    <div class="display-6 fs-6 text-center mt-5 mb-5">Not finding the product you're looking for? Contact us <a
            href="https://culturestudio.net/contact-us/">here</a></div>
</ng-template>